<section class="lead-hero curve -bottom -white" style="height: auto">
    <span class="photo"></span>
    <div class="intro">
        <div class="container">
            <div class="flow">
                <a href="/fund/compare">
                    <i class="icon icon-arrow-back"></i>
                    <span class="text">{{language.backfundcom}}</span>
                </a>
            </div>
            <div class="row">
                <div class="col-xl-6">
                    <h1 class="title">{{language.fundcompare1}}</h1>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="content-inner">
    <div class="container">
        <section class="big-group">
            <div class="row no-gutter">
                <div class="col-md-6" rel="group-column">
                    <article class="section-group">
                        <section class="name-fund">
                            <p class="text">{{language.fundcompare2}}</p>
                            <h1 class="title">
                                {{fundNameTh1}}
                                <span>{{fundNameEn1}}</span>
                            </h1>
                        </section>
                        <section class="risk-detail">
                            <ul class="list list-unstyled list-inline">
                                <li>
                                    <span class="group">
                                        <span class="thumb">
                                            <img *ngIf="riskSpectrumId1 === 1"
                                                src="../../../assets/images/risk/level-1@2x.png" alt="level 1"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId1 === 2"
                                                src="../../../assets/images/risk/level-2@2x.png" alt="level 2"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId1 === 3"
                                                src="../../../assets/images/risk/level-3@2x.png" alt="level 3"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId1 === 4"
                                                src="../../../assets/images/risk/level-4@2x.png" alt="level 4"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId1 === 5"
                                                src="../../../assets/images/risk/level-5@2x.png" alt="level 5"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId1 === 6"
                                                src="../../../assets/images/risk/level-6@2x.png" alt="level 6"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId1 === 7"
                                                src="../../../assets/images/risk/level-7@2x.png" alt="level 7"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId1 === 8"
                                                src="../../../assets/images/risk/level-8@2x.png" alt="level 8"
                                                class="img-responsive">
                                        </span>
                                        <span class="text">{{reskSpectrumTh1}}</span>
                                    </span>
                                </li>
                            </ul>
                        </section>
                    </article>
                </div>
                <div class="col-md-6" rel="group-column">
                    <article class="section-group">
                        <section class="name-fund">
                            <p class="text">{{language.fundcompare3}}</p>
                            <h1 class="title">
                                {{fundNameTh2}}
                                <span>{{fundNameEn2}}</span>
                            </h1>
                        </section>
                        <section class="risk-detail">
                            <ul class="list list-unstyled list-inline">
                                <li>
                                    <span class="group">
                                        <span class="thumb">
                                            <img *ngIf="riskSpectrumId2 === 1"
                                                src="../../../assets/images/risk/level-1@2x.png" alt="level 1"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId2 === 2"
                                                src="../../../assets/images/risk/level-2@2x.png" alt="level 2"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId2 === 3"
                                                src="../../../assets/images/risk/level-3@2x.png" alt="level 3"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId2 === 4"
                                                src="../../../assets/images/risk/level-4@2x.png" alt="level 4"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId2 === 5"
                                                src="../../../assets/images/risk/level-5@2x.png" alt="level 5"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId2 === 6"
                                                src="../../../assets/images/risk/level-6@2x.png" alt="level 6"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId2 === 7"
                                                src="../../../assets/images/risk/level-7@2x.png" alt="level 7"
                                                class="img-responsive">
                                            <img *ngIf="riskSpectrumId2 === 8"
                                                src="../../../assets/images/risk/level-8@2x.png" alt="level 8"
                                                class="img-responsive">
                                        </span>
                                        <span class="text">{{reskSpectrumTh2}}</span>
                                    </span>
                                </li>
                            </ul>
                        </section>
                    </article>
                </div>
            </div>
        </section>

        <section class="big-group">
            <div class="row no-gutter">
                <div class="col-md-6" rel="group-column">
                    <article class="section-group fund-detail">
                        <section class="info">
                            <header class="heading-title">
                                <h2 class="topic-title f-regular">
                                    <span rel="border-circle">
                                        <i class="icon icon-price"></i>
                                    </span>
                                    <span class="text">{{language.funddetailthm1b1detail11}} (THB)
                                        <span class="day">{{language.funddetailthm1b1detail12}}
                                            {{fundPriceDate1}}</span>
                                    </span>
                                </h2>
                            </header>
                            <section class="name-fund d-block d-md-none">
                                <p class="text">{{language.fundcompare2}}</p>
                                <h1 class="title">
                                    {{fundNameTh1}}
                                    <span>{{fundNameEn1}}</span>
                                </h1>
                            </section>
                        </section>
                        <section class="widget -stock">
                            <div class="value">
                                <span class="number">{{navPublish1}}</span>
                                <span class="index {{isPositive(navDiff1) ? 'up' : 'down'}}">
                                    <i class="icon icon-arrow-index"></i>
                                    <span>
                                        {{showOnlyValue(navDiff1)}}
                                        <small>({{showOnlyValue(NAVDiffPercent1)}}%) </small>
                                    </span>
                                </span>
                            </div>
                        </section>
                    </article>
                </div>

                <div class="col-md-6" rel="group-column">
                    <article class="section-group fund-detail">
                        <section class="info">
                            <header class="heading-title d-none d-md-block">
                                <h2 class="topic-title f-regular">
                                    <span rel="border-circle">
                                        <i class="icon icon-price"></i>
                                    </span>
                                    <span class="text">{{language.funddetailthm1b1detail11}} (THB)
                                        <span class="day">{{language.funddetailthm1b1detail12}}
                                            {{fundPriceDate2}}</span>
                                    </span>
                                </h2>
                            </header>
                            <section class="name-fund d-block d-md-none">
                                <p class="text">{{language.fundcompare3}}</p>
                                <h1 class="title">
                                    {{fundNameTh2}}
                                    <span>{{fundNameEn2}}</span>
                                </h1>
                            </section>
                        </section>
                        <section class="widget -stock">
                            <div class="value">
                                <span class="number">{{navPublish2}}</span>
                                <span class="index {{isPositive(navDiff2) ? 'up' : 'down'}}">
                                    <i class="icon icon-arrow-index"></i>
                                    <span>
                                        {{showOnlyValue(navDiff2)}}
                                        <small>({{showOnlyValue(NAVDiffPercent2)}}%) </small>
                                    </span>
                                </span>
                            </div>
                        </section>
                    </article>
                </div>
            </div>
        </section>

        <section class="big-group">
            <section class="section-group section-graph non-border">
                <header>
                    <h2 class="topic-title text-center">
                        <span rel="border-circle">
                            <i class="icon icon-graph-stock"></i>
                        </span>
                        <span class="text">{{language.funddetailthm2b1detail1}}</span>
                    </h2>
                </header>
                <div class="row">
                    <div class="col-lg-12">
                        <div style="width: 100%;">
                            <!-- <canvas baseChart [chartType]="'line'" [datasets]="lineChartData1" [labels]="chartLabels1" [options]="chartOptions"
                [colors]="chartColors1" [legend]="true">
              </canvas> -->
                            <div id="container" [chart]="chart_line"></div>
                        </div>
                    </div>
                </div>
                <ul class="list-inline list-year text-center d-none d-md-block">
                    <li>
                        <a class="indexSelector" (click)="onSearchGraph(1)"
                            [ngClass]="(index_v == 1)?'active':''">YTD</a>
                    </li>
                    <li>
                        <a class="indexSelector" (click)="onSearchGraph(2)"
                            [ngClass]="(index_v == 2)?'active':''">1M</a>
                    </li>
                    <li>
                        <a class="indexSelector" (click)="onSearchGraph(3)"
                            [ngClass]="(index_v == 3)?'active':''">3M</a>
                    </li>
                    <li>
                        <a class="indexSelector" (click)="onSearchGraph(4)"
                            [ngClass]="(index_v == 4)?'active':''">6M</a>
                    </li>
                    <li>
                        <a class="indexSelector" (click)="onSearchGraph(5)"
                            [ngClass]="(index_v == 5)?'active':''">1Y</a>
                    </li>
                    <li>
                        <a class="indexSelector" (click)="onSearchGraph(6)"
                            [ngClass]="(index_v == 6)?'active':''">3Y</a>
                    </li>
                    <li>
                        <a class="indexSelector" (click)="onSearchGraph(7)"
                            [ngClass]="(index_v == 7)?'active':''">5Y</a>
                    </li>
                    <li>
                        <a class="indexSelector" (click)="onSearchGraph(8)"
                            [ngClass]="(index_v == 8)?'active':''">10Y</a>
                    </li>
                    <li>
                        <a class="indexSelector" (click)="onSearchGraph(9)"
                            [ngClass]="(index_v == 9)?'active':''">{{language.funddetailthm2b1detail2}}</a>
                    </li>
                </ul>
            </section>
        </section>

        <section class="big-group section-port">
            <div class="row no-gutter">
                <div class="col-md-6" rel="group-column">
                    <article class="section-group" style="padding-left: 0; padding-top: 0">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-port"></i>
                                </span>
                                <span class="text">{{language.allocation5}}</span>
                            </h2>
                        </header>
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare2}}</p>
                            <h1 class="title">
                                {{fundNameTh1}}
                                <span>{{fundNameEn1}}</span>
                            </h1>
                        </section>
                        <div style="width:100%">
                            <div id="container" [chart]="donut_1"></div>
                        </div>

                        <div class="wrapper-investment">
                            <h4 class="sub-title text-center">{{language.funddetailthm1b7detail3}}</h4>
                            <section class="group-company">
                                <table class="table table--noborder -company">
                                    <tbody>
                                        <tr *ngFor="let item of topFiveHolding1">
                                            <th *ngIf="flag == 'th'">{{item.Key}}</th>
                                            <th *ngIf="flag == 'en'">{{item.KeyEn}}</th>
                                            <td>{{fixFloatDigit(item.Value)}}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </section>
                        </div>
                    </article>
                </div>

                <div class="col-md-6" rel="group-column">
                    <article class="section-group">
                        <header class="heading-title d-none d-md-block">

                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-port"></i>
                                </span>
                                <span class="text">{{language.allocation5}}</span>
                            </h2>
                        </header>
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare3}}</p>
                            <h1 class="title">
                                {{fundNameTh2}}
                                <span>{{fundNameEn2}}</span>
                            </h1>
                        </section>
                        <div style="width:100%">
                            <div id="container" [chart]="donut_2"></div>
                        </div>

                        <div class="wrapper-investment">
                            <h4 class="sub-title text-center">{{language.funddetailthm1b7detail3}}</h4>
                            <section class="group-company">
                                <table class="table table--noborder -company">
                                    <tbody>
                                        <tr *ngFor="let item of topFiveHolding2">
                                            <th *ngIf="flag == 'th'">{{item.Key}}</th>
                                            <th *ngIf="flag == 'en'">{{item.KeyEn}}</th>
                                            <td>{{fixFloatDigit(item.Value)}}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </section>
                        </div>
                    </article>
                </div>
            </div>
        </section>

        <section class="big-group section-policy">
            <div class="row no-gutter">
                <div class="col-md-6" rel="group-column">
                    <article class="secion-group -dividend">
                        <header class="heading-title">

                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-dividend"></i>
                                </span>
                                <span class="text">{{language.funddetailthm1b5detail14}}</span>
                            </h2>
                        </header>
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare2}}</p>
                            <h1 class="title">
                                {{fundNameTh1}}
                                <span>{{fundNameEn1}}</span>
                            </h1>
                        </section>
                        <p>{{investmentPolicy1}}</p>

                    </article>
                </div>
                <div class="col-md-6" rel="group-column">
                    <article class="secion-group -dividend">
                        <header class="heading-title d-none d-md-block">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-dividend"></i>
                                </span>
                                <span class="text">{{language.funddetailthm1b5detail14}}</span>
                            </h2>
                        </header>
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare3}}</p>
                            <h1 class="title">
                                {{fundNameTh2}}
                                <span>{{fundNameEn2}}</span>
                            </h1>
                        </section>

                        <p>{{investmentPolicy2}}</p>
                    </article>
                </div>
            </div>
        </section>

        <section class="big-group">
            <div class="row no-gutter">
                <div class="col-md-6" rel="group-column">
                    <article class="section-group section-fee -fund">
                        <header class="heading-title">

                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-e-chart"></i>
                                </span>
                                <span class="text">{{language.funddetailthmenu3}}</span>
                            </h2>
                        </header>
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare2}}</p>
                            <h1 class="title">
                                {{fundNameTh1}}
                                <span>{{fundNameEn1}}</span>
                            </h1>
                        </section>
                        <section class="section">
                            <h3 class="h4 title">
                                <i class="icon icon-buy"></i>
                                <span class="text">{{language.funddetailthm3b1detail2}}</span>
                            </h3>
                            <ul class="list list-unstyled list-bullet-fee">
                                <li>
                                    <span>{{language.funddetailthm3b1detail3}}</span>
                                    <span class="result">
                                        <em>{{minFirstTradeAmt1 | number}}</em>
                                        {{language.funddetailthm3b1detail4}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b1detail5}}</span>
                                    <span class="result">
                                        <em>{{minTradeAmt1 | number}}</em>
                                        {{language.funddetailthm3b1detail4}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b1detail6}}</span>
                                    <span class="result">
                                        <em>{{minFundGiftCard1 | number}}</em>
                                        {{language.funddetailthm3b1detail4}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b1detail7}}</span>
                                    <span class="result">
                                        <em>{{buyTime1}}</em>
                                        {{buyCondition1}}
                                    </span>
                                </li>
                            </ul>
                        </section>
                    </article>
                </div>

                <div class="col-md-6" rel="group-column">
                    <article class="section-group section-fee -fund">
                        <header class="heading-title d-none d-md-block">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-e-chart"></i>
                                </span>
                                <span class="text">{{language.funddetailthmenu3}}</span>
                            </h2>
                        </header>
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare3}}</p>
                            <h1 class="title">
                                {{fundNameTh2}}
                                <span>{{fundNameEn2}}</span>
                            </h1>
                        </section>
                        <section class="section">
                            <h3 class="h4 title">
                                <i class="icon icon-buy"></i>
                                <span class="text">{{language.funddetailthm3b1detail2}}</span>
                            </h3>
                            <ul class="list list-unstyled list-bullet-fee">
                                <li>
                                    <span>{{language.funddetailthm3b1detail3}}</span>
                                    <span class="result">
                                        <em>{{minFirstTradeAmt2 | number}}</em>
                                        {{language.funddetailthm3b1detail4}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b1detail5}}</span>
                                    <span class="result">
                                        <em>{{minTradeAmt2 | number}}</em>
                                        {{language.funddetailthm3b1detail4}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b1detail6}}</span>
                                    <span class="result">
                                        <em>{{minFundGiftCard2 | number}}</em>
                                        {{language.funddetailthm3b1detail4}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b1detail7}}</span>
                                    <span class="result">
                                        <em>{{buyTime2}}</em>
                                        {{buyCondition2}}
                                    </span>
                                </li>
                            </ul>
                        </section>
                    </article>
                </div>
            </div>

            <div class="row no-gutter">
                <div class="col-md-6" rel="group-column">
                    <article class="section-group section-fee -fund">
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare2}}</p>
                            <h1 class="title">
                                {{fundNameTh1}}
                                <span>{{fundNameEn1}}</span>
                            </h1>
                        </section>
                        <section class="section">
                            <h3 class="h4 title">
                                <i class="icon icon-sell"></i>
                                <span class="text">{{language.funddetailthm3b2detail1}}</span>
                            </h3>
                            <ul class="list list-unstyled list-bullet-fee">
                                <li>
                                    <span>{{language.funddetailthm3b2detail2}}</span>
                                    <span class="result">
                                        <em>{{minBalanceUnit1}}</em>
                                        {{language.funddetailthm3b2detail3}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b2detail4}}</span>
                                    <span class="result">
                                        {{minSellTradeAmt1}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b2detail5}}</span>
                                    <span class="result">
                                        {{minBalanceBath1}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b2detail6}}</span>
                                    <span *ngIf="flag == 'th'" class="result">
                                        <em>{{sellTime1}}</em>
                                        <br>
                                        {{language.fundcompare7}}
                                        <br>
                                        {{language.fundcompare8}}
                                        <br>
                                        {{language.fundcompare9}}
                                    </span>
                                    <span *ngIf="flag == 'en'" class="result">
                                        <em>{{sellTime1}}</em>
                                        <br>
                                        {{language.fundcompare7}}
                                        <br>
                                        {{language.fundcompare9}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b2detail7}}</span>
                                    <span class="result">
                                        <em>{{language.funddetailthm3b2detail8}} {{settlementDate1}}
                                            {{language.funddetailthm3b2detail9}}</em>
                                        <br>
                                        {{language.funddetailthm3b2detail10}} (T+{{settlementDate1}})
                                    </span>
                                </li>
                            </ul>
                        </section>
                    </article>
                </div>

                <div class="col-md-6" rel="group-column">
                    <article class="section-group section-fee -fund">
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare3}}</p>
                            <h1 class="title">
                                {{fundNameTh2}}
                                <span>{{fundNameEn2}}</span>
                            </h1>
                        </section>
                        <section class="section">
                            <h3 class="h4 title">
                                <i class="icon icon-sell"></i>
                                <span class="text">{{language.funddetailthm3b2detail1}}</span>
                            </h3>
                            <ul class="list list-unstyled list-bullet-fee">
                                <li>
                                    <span>{{language.funddetailthm3b2detail2}}</span>
                                    <span class="result">
                                        <em>{{minBalanceUnit2}}</em>
                                        {{language.funddetailthm3b2detail3}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b2detail4}}</span>
                                    <span class="result">
                                        {{minSellTradeAmt2}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b2detail5}}</span>
                                    <span class="result">
                                        {{minBalanceBath2}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b2detail6}}</span>
                                    <span *ngIf="flag == 'th'" class="result">
                                        <em>{{sellTime1}}</em>
                                        <br>
                                        {{language.fundcompare7}}
                                        <br>
                                        {{language.fundcompare8}}
                                        <br>
                                        {{language.fundcompare9}}
                                    </span>
                                    <span *ngIf="flag == 'en'" class="result">
                                        <em>{{sellTime1}}</em>
                                        <br>
                                        {{language.fundcompare7}}
                                        <br>
                                        {{language.fundcompare9}}
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b2detail7}}</span>
                                    <span class="result">
                                        <em>{{language.funddetailthm3b2detail8}} {{settlementDate2}}
                                            {{language.funddetailthm3b2detail9}}</em>
                                        <br>
                                        {{language.funddetailthm3b2detail10}} (T+{{settlementDate2}})
                                    </span>
                                </li>
                            </ul>
                        </section>
                    </article>
                </div>
            </div>

        </section>

        <section class="big-group">
            <div class="row no-gutter">
                <div class="col-md-6" rel="group-column">
                    <article class="section-group section-fee -dealing">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-cart-coin"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b3detail1}}</span>
                            </h2>
                        </header>
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare2}}</p>
                            <h1 class="title">
                                {{fundNameTh1}}
                                <span>{{fundNameEn1}}</span>
                            </h1>
                        </section>
                        <section>
                            <h3 class="h4 title">
                                <i class="icon icon-coin"></i>
                                <span class="text">
                                    {{language.funddetailthm3b3detail2}}
                                    <small>
                                        <br class="d-block d-sm-none d-md-none d-lg-none d-xl-none">
                                        {{language.funddetailthm3b3detail3}}
                                    </small>
                                </span>
                            </h3>
                            <ul class="list list-unstyled list-bullet-fee">
                                <li>
                                    <span>{{language.funddetailthm3b3detail4}}</span>
                                    <span class="result">
                                        <em>{{feeBuy1}}</em>
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b3detail5}}</span>
                                    <span class="result">
                                        <em>{{feeSell1}}</em>
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b3detail6}}</span>
                                    <span class="result">
                                        <em>{{feeSwitchIn1}}</em>
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b3detail7}}</span>
                                    <span class="result">
                                        <em>{{feeSwitchOut1}}</em>
                                    </span>
                                </li>
                            </ul>
                        </section>
                        <footer class="section-group" style="padding-top: 40px">
                            <a (click)="goToFundDetail(fundId1)" class="btn btn-primary -brand">{{language.fundcompare6}}</a>
                        </footer>
                    </article>
                </div>

                <div class="col-md-6" rel="group-column">
                    <article class="section-group section-fee -dealing">
                        <header class="heading-title d-none d-md-block">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-cart-coin"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b3detail1}}</span>
                            </h2>
                        </header>
                        <section class="name-fund d-block d-md-none">
                            <p class="text">{{language.fundcompare3}}</p>
                            <h1 class="title">
                                {{fundNameTh2}}
                                <span>{{fundNameEn2}}</span>
                            </h1>
                        </section>
                        <section>
                            <h3 class="h4 title">
                                <i class="icon icon-coin"></i>
                                <span class="text">
                                    {{language.funddetailthm3b3detail2}}
                                    <small>
                                        <br class="d-block d-sm-none d-md-none d-lg-none d-xl-none">
                                        {{language.funddetailthm3b3detail3}}
                                    </small>
                                </span>
                            </h3>
                            <ul class="list list-unstyled list-bullet-fee">
                                <li>
                                    <span>{{language.funddetailthm3b3detail4}}</span>
                                    <span class="result">
                                        <em>{{feeBuy2}}</em>
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b3detail5}}</span>
                                    <span class="result">
                                        <em>{{feeSell2}}</em>
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b3detail6}}</span>
                                    <span class="result">
                                        <em>{{feeSwitchIn2}}</em>
                                    </span>
                                </li>
                                <li>
                                    <span>{{language.funddetailthm3b3detail7}}</span>
                                    <span class="result">
                                        <em>{{feeSwitchOut1}}</em>
                                    </span>
                                </li>
                            </ul>
                        </section>
                        <footer class="section-group ">
                            <a (click)="goToFundDetail(fundId2)" class="btn btn-primary -brand">{{language.fundcompare6}}</a>
                            
                        </footer>
                    </article>
                </div>
            </div>
        </section>
    </div>
</section>

<ngx-ui-loader></ngx-ui-loader>